module.exports = __webpack_public_path__ + "static/media/logo.6f40e8d7.png";